"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("@CommonFrontendBackend/Accept/Types");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var InlineAcceptHeader_1 = require("AcceptFlow/Utils/InlineAcceptHeader");
var SecuredByQwilr_1 = require("AcceptFlow/Utils/SecuredByQwilr");
var MountReactComponent_1 = __importDefault(require("MountReactComponent/MountReactComponent"));
var SentMainContent_1 = require("./SentMainContent");
var Sent = (function () {
    function Sent(createUi, acceptUtils, usingFeature, closeAll, getPoweredByQwilr, badgeClickUrl, settings, onPostAcceptance, onShowExperienceSurvey, $timeout, acceptTelemetry, isPreviewMode, acceptData, di) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        var completionText;
        var utmMedium;
        var view;
        var continueLabel;
        var continueAction = closeAll;
        var buttonLink = "//".concat(badgeClickUrl, "?utm_source=qwilr-branding&utm_medium=qwilr-accept-flow-viral&utm_campaign=try-qwilr-yourself");
        var showClose = true;
        var close = closeAll;
        var postAcceptance = settings.postAcceptance;
        var isUsingPostAccept = usingFeature(FeatureFlag_1.FeatureFlag.PostAcceptExperience) &&
            postAcceptance.enabled &&
            postAcceptance.action === Types_1.PostAcceptanceAction.Redirect;
        var surveyTimeout = null;
        var startSurveyTimeout = function () {
            if (!isUsingPostAccept) {
                surveyTimeout = $timeout(showSurvey, 3000);
            }
        };
        var isShowingSurvey = false;
        var showSurvey = function () {
            if (surveyTimeout) {
                $timeout.cancel(surveyTimeout);
            }
            onShowExperienceSurvey();
            isShowingSurvey = true;
        };
        var isUsingInlineForm = !usingFeature(FeatureFlag_1.FeatureFlag.OptOutNewEditor);
        var isLastOrOnlyAccepter = settings.accepters.number === 1 ||
            ((_b = (_a = settings.accepters.finalisedAccepters) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + 1 === settings.accepters.number;
        if ((_c = settings.button) === null || _c === void 0 ? void 0 : _c.custom) {
            completionText = (_d = settings.button) === null || _d === void 0 ? void 0 : _d.customCompletionText;
        }
        else if (!isLastOrOnlyAccepter) {
            completionText =
                "Congratulations! You have accepted the page. Once everyone has accepted this project, you’ll receive a PDF record of this document.";
        }
        else {
            completionText = "Congratulations! The page has been accepted. A signed PDF copy has been emailed to you.";
        }
        if (usingFeature(FeatureFlag_1.FeatureFlag.ViralAcceptFlow)) {
            view = require("./ViralSent.html");
            utmMedium = "qwilr-accept-flow-viral";
            continueLabel = "Back";
        }
        else {
            view = require("./Sent.html");
            utmMedium = acceptUtils.utmMedium;
            continueLabel = "Done";
        }
        if (isUsingPostAccept) {
            continueLabel = ((_e = settings.postAcceptance) === null || _e === void 0 ? void 0 : _e.continueLabel) || Types_1.DEFAULT_POST_ACCEPTANCE_REDIRECT_LABEL;
            continueAction = onPostAcceptance;
            showClose = false;
        }
        else {
            continueAction = function () {
                if (!isShowingSurvey) {
                    showSurvey();
                }
                closeAll();
            };
        }
        var viewData = {
            utmMedium: utmMedium,
            poweredByQwilr: isUsingInlineForm
                ? (0, SecuredByQwilr_1.mountAcceptFlowSecuredByQwilrBtn)((0, MountReactComponent_1.default)(createUi))
                : getPoweredByQwilr(acceptUtils.utmMedium, "white"),
            completionText: completionText,
            buttonLink: buttonLink,
            continueLabel: continueLabel,
            continueAction: continueAction,
            showClose: showClose,
            close: close,
            isUsingInlineForm: isUsingInlineForm,
            inlineHeader: (0, InlineAcceptHeader_1.mountHeader)((0, MountReactComponent_1.default)(createUi), {
                screen: InlineAcceptHeader_1.AcceptScreen.Accepted,
                telemetry: acceptTelemetry,
            }),
            mainContent: (0, SentMainContent_1.mountSentMainContent)((0, MountReactComponent_1.default)(createUi, di), {
                continueAction: function () { return $timeout(continueAction); },
                continueLabel: continueLabel,
                postAcceptanceEnabled: isUsingPostAccept,
                isUsingInlineForm: isUsingInlineForm,
                completionText: completionText,
                acceptData: acceptData,
                esignEnabled: settings.esignEnabled,
                isPreviewMode: isPreviewMode,
                onDownload: function () {
                    return acceptTelemetry.track("Accepted PDF Downloaded", { accepted_pdf_downloaded_source: "success" });
                },
                acceptTelemetry: acceptTelemetry,
            }),
            $init: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    startSurveyTimeout();
                    return [2];
                });
            }); },
        };
        this.ui = createUi(view, viewData);
    }
    return Sent;
}());
exports.default = Sent;
